export const checkHtmlAndLengthValidation = (name, str, minLength = 0, maxLength = 100) => {
  const pattern = /<[^>]*>/;
  if (!str) {
    return `${name} is required.`;
  }
  if (str?.length < minLength) {
    return `${name} should contain minimum ${minLength} characters.`;
  }
  if (str?.length > maxLength) {
    return `${name} can not exceed ${maxLength} characters.`;
  }
  if (pattern.test(str)) {
    return `${name} has invalid characters`;
  }
  return null;
};

export const userSearch = (user, searchText) => {
  return (
    user.name.toLowerCase().includes(searchText.toLowerCase()) ||
    user.uid?.toLowerCase().includes(searchText.toLowerCase()) ||
    user.email?.toLowerCase().includes(searchText.toLowerCase())
  );
};

export function formatNumber(num) {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  } else {
    return num.toString();
  }
}

export const INVALID_CHARS_REGEX = /[~!@#$%^&*()]/;